import {combineReducers} from 'redux'
import createCommonReducer from './common/reducer'
import createKanbanReducer from './kanban/reducer'
import createTaskTableReducer from './tasksTable/reducer'
import taskSelection from './taskSelection/reducer'
import createColumnConfiguratorMenuReducer from './tasksTable/configurationMenu/reducer'
import createCPPanelReducer from './customersProjectsPanel/reducer'
import bulkOperationsPanel from './bulkOperations/reducer'
import createStatusFilterReducer from '../workflowStatus/components/statusFilter/reducer'
import exportCsvTaskList from './exportCsv/reducer'

const createTaskManagementReducer = (initAppData) => {
    return combineReducers({
        common: createCommonReducer(initAppData),
        kanban: createKanbanReducer(initAppData),
        taskTable: createTaskTableReducer(initAppData),
        taskSelection,
        columnConfiguratorMenu: createColumnConfiguratorMenuReducer(initAppData),
        statusFilter: createStatusFilterReducer(initAppData),
        cpPanel: createCPPanelReducer(initAppData),
        bulkOperationsPanel,
        exportCsvTaskList,
    })
}

export default createTaskManagementReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/reducer.js